import axios from 'axios';
import { config } from 'shared/config';
import { primeSharedResource, readSharedResource } from 'shared/api/readResource';

const catalogKey = (userId: string) => `reports:catalog:${userId}`;
export const REPORT_NAME_LIMIT = 50; // dbo.Report.ReportName is nvarchar(50), counted in UTF-16 code units.

/** The one read of the caller's report list (the server lists the signed-in person's reports). */
export const loadReportCatalog = async (signal?: AbortSignal): Promise<any[]> => {
    const response = await axios.get(`${config.API_URL}/api/reports`, { signal, timeout: 10000 });
    return response.data;
};

/** Start the home list read while the route's access checks are still in flight. */
export const primeReportCatalog = (userId: string): void => {
    void primeSharedResource(catalogKey(userId), () => loadReportCatalog());
};

/** The first list read: shares a primed or in-flight read, else fetches. */
export const readInitialReportCatalog = (userId: string) =>
    readSharedResource(catalogKey(userId), () => loadReportCatalog());
